import React from "react";
import { Link } from "yarrr";
import { ChevronRight } from "lucide-react";

import { Text } from "../Text";
import css from "./styles.styl";

/**
 * Breadcrumbs
 * @param {Object} props
 * @param {Array} props.crumbs - The list of crumbs to display
 */
export const Breadcrumbs = (props) => {
	const { crumbs } = props;

	return (
		<div className={css.breadcrumbs}>
			{crumbs.map((crumb, index) => (
				<>
					<div key={crumb.href} className={`${css.crumb} ${index === crumbs.length - 1 ? css.last : ""}`}>
						{crumb.href ? (
							<Link href={crumb.href}>{crumb.label}</Link>
						) : (
							<div onClick={crumb?.onClick} role="button" tabIndex={0}>
								{crumb.label}
							</div>
						)}
					</div>

					{index < crumbs.length - 1 && (
						<ChevronRight
							key={`separator-${crumb.href}`}
							size={16}
							className={css.separator}
						/>
					)}
				</>
			))}
		</div>
	);
};
